// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-bottom {\n  border-bottom: 1px solid lightgray;\n}\n.border-top {\n  border-top: 1px solid lightgray;\n}\n.border-left {\n  border-left: 1px solid lightgray;\n}\n.border-right {\n  border-right: 1px solid lightgray;\n}", ""]);
// Exports
module.exports = exports;
